<div class="app-page" style="width: 100%; display: flex; justify-content: center;">
    <div style="display: flex; flex-direction: column; max-width: 480px;">

        <div style="display: flex;flex-direction: column; align-items: center;">
            <mat-icon style="font-size: 100px; width: 100px; height: 100px;">
                account_circle
            </mat-icon>
            <h2 >{{this._globals.UserFullName}}</h2>
            <div style="display: flex; gap: 12px; margin-top: 12px;">
                <button mat-raised-button color="accent" (click)="openChangePasswordDialog()">{{'GENERAL.CHANGEPASSWORD' | translate }}</button>
                <button mat-raised-button color="primary" (click)="logout()">{{'GENERAL.LOGOUT' | translate }}</button>
            </div>
        </div>
        <br/>
        <mat-divider></mat-divider>
        <br/>
        <span>{{'GENERAL.SETTINGS' | translate | uppercase }}</span>
        <div>
            <mat-form-field  appearance="fill">
                <mat-label>{{'GENERAL.LANGUAGE' | translate }}</mat-label>
                    <mat-select [(ngModel)]="language" (ngModelChange)="changeLanguage($event)" placeholder="{{'GENERAL.LANGUAGE' | translate}}">
                        <mat-option value="en-US">English</mat-option>
                        <mat-option value="sv-SE">Svenska</mat-option>
                    </mat-select>
            </mat-form-field>
            <br/>
            <mat-form-field  appearance="fill">
                <mat-label>{{'GENERAL.THEME' | translate }}</mat-label>
                <mat-select [(ngModel)]="theme" (ngModelChange)="changeTheme($event)">
                    <mat-option value="light">{{'GENERAL.THEMELIGHT' | translate }}</mat-option>
                    <mat-option value="dark">{{'GENERAL.THEMEDARK' | translate }}</mat-option>
                  
                </mat-select>
            </mat-form-field>
        </div>
    
    </div>  


</div>
